import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Stack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Thumbnail,
  Text,
  Toast,
  List,
  InlineError,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
const AddEditPortfolio = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(false);
  const handleChangeTitle = (value) => {
    setItem({
      ...item,
      title: value,
      alias: slugify(value),
      seoTitle: slugify(value),
    });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeAlias = (value) => {
    setItem({ ...item, alias: value });
    setAliasError("");
  };
  const [aliasError, setAliasError] = useState("");
  const handleChangeDescription = (value) => {
    setItem({ ...item, description: value });
  };
  const handleChangeText = (value) => {
    setItem({ ...item, text: value });
  };
  const handleChangeArchitect = (value) => {
    setItem({ ...item, architect: value });
  };
  const handleChangeClient = (value) => {
    setItem({ ...item, client: value });
  };
  const handleChangeScopeOfWork = (value) => {
    setItem({ ...item, scopeOfWork: value });
  };
  const handleChangeElectricalConsultant = (value) => {
    setItem({ ...item, electricalConsultant: value });
  };
  const handleChangeMechanicalConsultant = (value) => {
    setItem({ ...item, mechanicalConsultant: value });
  };
  const handleChangeConsultant = (value) => {
    setItem({ ...item, consultant: value });
  };
  const handleChangeLocation = (value) => {
    setItem({ ...item, location: value });
  };
  const handleChangeDate = (value) => {
    setItem({ ...item, date: value });
  };
  const handleChangeVimeoId = (value) => {
    setItem({ ...item, vimeoId: value });
  };
  const handleChangeMetaTitle = (value) => {
    setItem({ ...item, seoTitle: value });
  };
  const handleChangeMetaDescription = (value) => {
    setItem({ ...item, seoDescription: value });
  };
  const handleChangeChecked = (value) => {
    setItem({ ...item, active: value });
  };
  const handleChangeFeatured = (value) => {
    setItem({ ...item, featured: value });
  };
  const handleSelectChangeCategory = (value) => {
    setItem({ ...item, category: value });
    setCategoryError("");
  };
  const handleSelectChangeCountry = (value) => {
    setItem({ ...item, country: value });
    setCountryError("");
  };
  const [categoryError, setCategoryError] = useState("");
  const [countryError, setCountryError] = useState("");

  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs,webp and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", file[file.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeySeo.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          seoImage:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [filesMain, setFilesMain] = useState();
  const handleDropZoneMain = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMain((filesMain) => acceptedFiles[0]),
    []
  );
  const fileUploadMain = !filesMain && <DropZone.FileUpload />;
  const uploadedFilesMain = filesMain && (
    <Stack>
      <div className="maxtextwidth">
        {filesMain.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMain.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const imageKeyThumbnail = useRef("");
  const imageKeySeo = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImageMain = (filesMain) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", filesMain[filesMain.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesMain[filesMain.length - 1].type) > 0
              ? window.URL.createObjectURL(filesMain[filesMain.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesThumbnail, setFilesThumbnail] = useState();
  const handleDropZoneThumbnail = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesThumbnail((filesThumbnail) => acceptedFiles[0]),
    []
  );
  const fileUploadThumbnail = !filesThumbnail && <DropZone.FileUpload />;
  const uploadedFilesThumbnail = filesThumbnail && (
    <Stack>
      <div className="maxtextwidth">
        {filesThumbnail.name}{" "}
        <Text variant="bodySm" as="p">
          {filesThumbnail.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageThumbnail = (filesThumbnail) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", filesThumbnail[filesThumbnail.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyThumbnail.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          thumbnail:
            validImageTypes.indexOf(
              filesThumbnail[filesThumbnail.length - 1].type
            ) > 0
              ? window.URL.createObjectURL(
                  filesThumbnail[filesThumbnail.length - 1]
                )
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [item, setItem] = useState({
    title: "",
    alias: "",
    client: "",
    scopeOfWork: "",
    electricalConsultant: "",
    mechanicalConsultant: "",
    location: "",
    date: "",
    description: "",
    text: "",
    image: "",
    thumbnail: "",
    seoImage: "",
    seoTitle: "",
    seoDescription: "",
    seoImage: "",
    active: true,
    vimeoId: "",
    featured: false,
    category: "",
    image: "",
    thumbnail: "",
    country: "",
    architect: "",
    consultant: "",
  });

  useEffect(() => {
    fetchData();
  }, []);
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [optionsCategories, setOptionsCategories] = useState([]);

  async function fetchData() {
    let responseCountries = "";
    let responseCategories = "";
    let responseItem = "";
    try {
      responseCategories = await axios.get(`/categories?per_page=1000`);
      setOptionsCategories(
        responseCategories.data.data.data.map((item, index) => {
          return {
            label: item?.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCountries = await axios.get(`/countries`);
      setOptionsCountries(
        responseCountries.data.data.data.map((item, index) => {
          return {
            label: item?.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props?.type === "edit")
      try {
        responseItem = await axios.get(`/portfolios/${id}`);
        setItem({
          title: responseItem?.data?.data?.title
            ? responseItem.data.data.title
            : "",
          category:
            responseItem?.data?.data?.category_id !== null
              ? String(responseItem.data.data.category_id)
              : "",
          country:
            responseItem?.data?.data?.country_id !== null
              ? String(responseItem.data.data.country_id)
              : "",
          alias: responseItem?.data?.data?.alias
            ? responseItem.data.data.alias
            : "",
          client: responseItem?.data?.data?.client
            ? responseItem.data.data.client
            : "",
          scopeOfWork: responseItem?.data?.data?.work_scope
            ? responseItem.data.data.work_scope
            : "",
          electricalConsultant: responseItem?.data?.data?.electrical_consultant
            ? responseItem.data.data.electrical_consultant
            : "",
          mechanicalConsultant: responseItem?.data?.data?.mechanical_consultant
            ? responseItem.data.data.mechanical_consultant
            : "",
          consultant: responseItem?.data?.data?.consultant
            ? responseItem.data.data.consultant
            : "",
          location: responseItem?.data?.data?.location
            ? responseItem.data.data.location
            : "",
          date: responseItem?.data?.data?.date
            ? responseItem.data.data.date
            : "",
          architect: responseItem?.data?.data?.architect
            ? responseItem.data.data.architect
            : "",
          description: responseItem?.data?.data?.description
            ? responseItem.data.data.description
            : "",
          text: responseItem?.data?.data?.text
            ? responseItem.data.data.text
            : "",
          seoTitle: responseItem?.data?.data?.seo_title
            ? responseItem.data.data.seo_title
            : "",
          seoDescription: responseItem?.data?.data?.seo_description
            ? responseItem.data.data.seo_description
            : "",
          seoImage: responseItem?.data?.data?.seo_image
            ? responseItem.data.data.seo_image
            : "",
          image: responseItem?.data?.data?.image
            ? responseItem.data.data.image
            : "",
          thumbnail: responseItem?.data?.data?.mobile_image
            ? responseItem.data.data.mobile_image
            : "",
          seoImage: responseItem?.data?.data?.seo_image
            ? responseItem.data.data.seo_image
            : "",
          active: responseItem?.data?.data?.is_active ? true : false,
          featured: responseItem?.data?.data?.is_featured ? true : false,
        });

        setIsSaving(false);
      } catch (error) {
        console.log(error);
      }
  }
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Item`}
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/portfolio`),
        },
      ]}
    >
      <FormLayout>
        <Card sectioned>
          <FormLayout>
            <Checkbox
              label="Is Featured"
              checked={item.featured}
              onChange={handleChangeFeatured}
            />
            <Select
              label="Category"
              options={optionsCategories}
              onChange={handleSelectChangeCategory}
              value={item.category}
              error={categoryError}
              placeholder="Please select"
            />
            <Select
              label="Country"
              options={optionsCountries}
              onChange={handleSelectChangeCountry}
              value={item.country}
              placeholder="Please select"
              error={countryError}
            />
            <FormLayout.Group>
              <TextField
                label="Title"
                value={item.title}
                onChange={handleChangeTitle}
                error={titleError}
              />

              <TextField
                label="Alias"
                value={item.alias}
                onChange={handleChangeAlias}
                error={aliasError}
              />
            </FormLayout.Group>

            <FormLayout.Group>
              <TextField
                label="Client"
                value={item.client}
                onChange={handleChangeClient}
              />

              <TextField
                label="Scope of Work"
                value={item.scopeOfWork}
                onChange={handleChangeScopeOfWork}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Electrical Consultant"
                value={item.electricalConsultant}
                onChange={handleChangeElectricalConsultant}
              />

              <TextField
                label="Mechanical Consultant"
                value={item.mechanicalConsultant}
                onChange={handleChangeMechanicalConsultant}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Consultant"
                value={item.consultant}
                onChange={handleChangeConsultant}
              />

              <TextField
                label="Architect"
                value={item.architect}
                onChange={handleChangeArchitect}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Location"
                value={item.location}
                onChange={handleChangeLocation}
              />
              <TextField
                label="Date"
                value={item.date}
                onChange={handleChangeDate}
              />
            </FormLayout.Group>

            {/* <TextField
              label="Vimeo ID"
              value={item.vimeoId}
              onChange={handleChangeVimeoId}
            /> */}
            <FormLayout.Group>
              <TextField
                label="Description"
                value={item.description}
                onChange={handleChangeDescription}
                multiline={4}
              />

              <TextField
                label="Text"
                value={item.text}
                onChange={handleChangeText}
                multiline={4}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.image ? item.image : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneMain}
                      onDropAccepted={sendImageMain}
                      allowMultiple={false}

                      // variableHeight
                    >
                      {uploadedFilesMain}
                      {fileUploadMain}
                    </DropZone>
                  </div>
                </div>
                <InlineError message={imageError} />
              </FormLayout>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Mobile Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.thumbnail ? item.thumbnail : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneThumbnail}
                      onDropAccepted={sendImageThumbnail}
                      allowMultiple={false}
                      // variableHeight
                    >
                      {uploadedFilesThumbnail}
                      {fileUploadThumbnail}
                    </DropZone>
                  </div>
                </div>
              </FormLayout>
            </FormLayout.Group>
          </FormLayout>
        </Card>
        <Card sectioned title="Search engine listing preview">
          <FormLayout>
            <Text variant="bodyMd" as="p" fontWeight="regular">
              SEO Image
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail
                  size="large"
                  source={item.seoImage ? item.seoImage : ""}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
            <TextField
              label="Page Title"
              value={item.seoTitle}
              onChange={handleChangeMetaTitle}
            />
            <TextField
              label="Description"
              value={item.seoDescription}
              onChange={handleChangeMetaDescription}
              multiline={4}
            />
          </FormLayout>
        </Card>
        <FormLayout.Group condensed>
          <Card sectioned title="Visibility">
            <FormLayout>
              <Checkbox
                label="Is Active"
                checked={item.active}
                onChange={handleChangeChecked}
              />
              {/* <ChoiceList
                choices={[
                  { label: "Visible", value: "visible" },
                  { label: "Hidden", value: "hidden" },
                ]}
                selected={selected}
                onChange={handleChoiceListChange}
              /> */}

              {/* {visibilityButtonText === "Clear date" && (
                <FormLayout.Group>
                  <TextField
                    label="Visibility Date"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="date"
                  />
                  <TextField
                    label="Visibility Time"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="time"
                  />
                </FormLayout.Group>
              )} */}
              {/* <Button plain onClick={handleVisibilityButton}>
                {visibilityButtonText}
              </Button> */}
            </FormLayout>
          </Card>
        </FormLayout.Group>
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/portfolios/${id}`)
                  .then((result) => {
                    navigate(`/admin/portfolio`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.title ||
      !item.alias ||
      item.category === "" ||
      item.country === ""
    ) {
      !item.title && setTitleError("This field is required");
      !item.alias && setAliasError("This field is required");
      item.category === "" && setCategoryError("Please select a category");
      item.country === "" && setCountryError("Please select a category");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.title && form_data.append("title", item.title);
      form_data.append("alias", item.alias);
      form_data.append("client", item.client);
      form_data.append("work_scope", item.scopeOfWork);
      form_data.append("electrical_consultant", item.electricalConsultant);
      form_data.append("consultant", item.consultant);
      form_data.append("mechanical_consultant", item.mechanicalConsultant);
      form_data.append("location", item.location);
      form_data.append("date", item.date);
      form_data.append("description", item.description);
      form_data.append("text", item.text);
      form_data.append("seo_title", item.seoTitle);
      form_data.append("seo_description", item.seoDescription);
      form_data.append("is_active", item.active ? 1 : 0);
      form_data.append("is_featured", item.featured ? 1 : 0);
      form_data.append("country_id", item.country);
      form_data.append("architect", item.architect);
      props.type === "edit" && form_data.append("_method", "PATCH");
      imageKeySeo.current && form_data.append("seo_image", imageKeySeo.current);
      imageKey.current && form_data.append("image", imageKey.current);
      imageKeyThumbnail.current &&
        form_data.append("mobile_image", imageKeyThumbnail.current);
      form_data.append("category_id", item.category);
      axios
        .post(`/portfolios${props.type === "edit" ? `/${id}` : ""}`, form_data)
        .then((res) => {
          if (props.type === "add") {
            navigate(`/admin/portfolio`);
          } else {
            setIsSaving(false);
            setToastContent("Changes have been saved succesffully");
            toggleActiveToast();
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            setIsSaving(false);
            setAliasError(error.response.data.message);
          } else if (error.request) {
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};

export default AddEditPortfolio;
